var map = {
	"./airplane.svg": 194,
	"./city.svg": 195,
	"./doubleLeaf.svg": 196,
	"./forest.svg": 197,
	"./house.svg": 198,
	"./leaf.svg": 199,
	"./natcap.png": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;